import { render, staticRenderFns } from "./AttackWarning.vue?vue&type=template&id=34d6f0e5&scoped=true&"
import script from "./AttackWarning.vue?vue&type=script&lang=js&"
export * from "./AttackWarning.vue?vue&type=script&lang=js&"
import style0 from "./AttackWarning.vue?vue&type=style&index=0&id=34d6f0e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d6f0e5",
  null
  
)

export default component.exports